import { CSSObject, Theme } from '@mui/material';
import {
  DROPDOWN_LIST_PADDING,
  getDropdownPaperStyles,
  getDropdownSurfaceActiveBackground,
} from '@onevision-resources/design-theme';

/** Shared surface + row styling for MUI `Menu` dropdowns (AppMenu and its submenus). */
export const getDropdownMenuPaperSx = (theme: Theme): CSSObject => {
  const activeBackground = getDropdownSurfaceActiveBackground(theme);
  return {
    ...getDropdownPaperStyles(theme),
    padding: 0,
    '& .MuiList-root': { padding: DROPDOWN_LIST_PADDING },
    '& .MuiMenuItem-root': {
      borderRadius: '0.5rem',
      marginBottom: '0.25rem',
      '&:hover': { backgroundColor: activeBackground },
      '&.Mui-selected': {
        backgroundColor: activeBackground,
        '&:hover': { backgroundColor: activeBackground },
      },
    },
  };
};
